import * as ng from 'angular';
import * as _ from 'underscore';

import { TableChart, TableChartFactory, PieChart, Dataset, DatasetField } from '..';

ng.module('e360')
   .factory('npsPieChartFactory', npsPieChartFactory);

npsPieChartFactory.$inject = ['instanceServiceFactory'];
function npsPieChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(NpsPieChart);
}

// Requires two data rows (pre/post) in the array with properties detractors passives and promoters
export class NpsPieChart {
   static $inject = ['ds', 'tableChartFactory'];

   tableChart:TableChart;
   prePieChart:PieChart;
   postPieChart:PieChart;

   constructor(private ds:Dataset, tableChartFactory:TableChartFactory) {
      var container = ng.element(`#${ds.id}`);
      container.append(`<div id="${ds.id}-table" class="chart-component table-chart"></div>`);
      container.append(`<div id="${ds.id}-pre" class="chart-component pie-chart"></div>`);
      container.append(`<div id="${ds.id}-post" class="chart-component pie-chart"></div>`);

      let options = {
         colors: ['#f2aa92', '#ffe699', '#92d14f'],
         plotOptions: {
            pie: {
               showInLegend: true,
               dataLabels: {
                  format: '{point.percentage:.1f} %'
               }
            }
         }
      };

      this.prePieChart = new PieChart(new Dataset({id: ds.id + '-pre', title: 'Pre-Ride'}), options);
      this.postPieChart = new PieChart(new Dataset({id: ds.id + '-post', title: 'Post-Ride'}), options);

      let tableDataset = new Dataset({
         id: ds.id + '-table',
         fields: [
            new DatasetField({
               name: 'score',
               label: '',
               type: 'text'
            }),
            new DatasetField({
               name: 'preRide',
               label: 'Pre-Ride',
               type: 'number'
            }),
            new DatasetField({
               name: 'postRide',
               label: 'Post-Ride',
               type: 'number'
            }),
            new DatasetField({
               name: 'change',
               label: 'Change',
               type: 'number'
            })
         ]
      });

      this.tableChart = tableChartFactory({ds: tableDataset});
   }

   setData(data:any[]) {
      let pre = data[0];
      let post = data[1];

      this.prePieChart.setData(this.getPieData(pre));
      this.postPieChart.setData(this.getPieData(post));

      let tableData = this.getTableData(pre, post);
      this.tableChart.setData(tableData);
   }

   private getPieData(data) {
      if (data && (data.detractors > 0 || data.passives > 0 || data.promoters > 0)) {
         return [
            { score: 'Detractors', value: data.detractors },
            { score: 'Passives', value: data.passives },
            { score: 'Promoters', value: data.promoters }
         ];
      }

      return [];
   }

   private getTableData(pre, post) {
      if (!post) {
         post = {detractors: NaN, passives: NaN, promoters: NaN};
      }

      let preTotal = pre.detractors + pre.passives + pre.promoters;
      let postTotal = post.detractors + post.passives + post.promoters;
      let preNps = Math.round(((pre.promoters / preTotal) - (pre.detractors / preTotal)) * 100);
      let postNps = Math.round(((post.promoters / postTotal) - (post.detractors / postTotal)) * 100);

      return [
         {
            score: 'Promoters',
            preRide: pre.promoters,
            postRide: post.promoters,
            change: post.promoters - pre.promoters
         },
         {
            score: 'Passives',
            preRide: pre.passives,
            postRide: post.passives,
            change: post.passives - pre.passives
         },
         {
            score: 'Detractors',
            preRide: pre.detractors,
            postRide: post.detractors,
            change: post.detractors - pre.detractors
         },
         {
            score: 'Total',
            preRide: preTotal,
            postRide: postTotal,
            change: postTotal - preTotal
         },
         {
            score: 'NPS',
            preRide: preNps,
            postRide: postNps,
            change: postNps - preNps
         }
      ];
   }

   onLoadStart() {
      this.prePieChart.onLoadStart();
      this.postPieChart.onLoadStart();
   }

   onLoadFinish() {
      this.prePieChart.onLoadFinish();
      this.postPieChart.onLoadFinish();
   }
}

export interface NpsPieChartFactory {
   ({ds:Dataset}):NpsPieChart;
}
